import { __module as addClass } from '../../../../../_virtual/addClass.js';
import { i as interopRequireDefaultExports } from '../../../../@babel/runtime/helpers/interopRequireDefault.js';
import { __require as requireHasClass } from './hasClass.js';

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports;

	exports.__esModule = true;
	exports.default = addClass;

	var _hasClass = _interopRequireDefault(requireHasClass());

	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}

	module.exports = exports["default"]; 
} (addClass, addClass.exports));

var addClassExports = addClass.exports;

export { addClassExports as a };
